'use client'

import type { Editor } from '@tiptap/react'
import { listButtonsBasic, taskListButton } from './editor-toolbar.config'
import { EditorToolbarButton } from './editor-toolbar-button.atom'
import { EditorToolbarButtonGroup } from './editor-toolbar-button-group.atom'
import { EditorToolbarDivider } from './editor-toolbar-divider.atom'

export interface EditorToolbarListsProps {
  editor: Editor
  isDisabled?: boolean
  isShowTaskList?: boolean
}

/**
 * List buttons section (bullet, numbered, task lists)
 */
export const EditorToolbarLists = ({
  editor,
  isDisabled = false,
  isShowTaskList = true,
}: EditorToolbarListsProps) => (
  <>
    <EditorToolbarDivider />
    <EditorToolbarButtonGroup
      editor={editor}
      buttonList={listButtonsBasic}
      isDisabled={isDisabled}
    />
    {isShowTaskList && (
      <EditorToolbarButton
        label={taskListButton.label}
        shortcut={taskListButton.shortcut}
        isActive={taskListButton.isActive?.(editor)}
        onClick={() => taskListButton.action(editor)}
        disabled={isDisabled}
      >
        <taskListButton.icon className="size-4" />
      </EditorToolbarButton>
    )}
  </>
)

EditorToolbarLists.displayName = 'EditorToolbarLists'
